import { RouteObject } from "react-router-dom";
import {
  ONBOARDING,
  ONBOARDING_MANUAL,
  ONBOARDING_LINKEDIN,
  ONBOARDING_RESUME,
} from "constants/urls";

export default [
  {
    path: ONBOARDING,
    lazy: () => import("modules/onboarding/pages/Onboarding"),
  },
  {
    path: ONBOARDING_MANUAL,
    lazy: () => import("modules/onboarding/pages/OnboardingFreelancerManual"),
  },
  {
    path: ONBOARDING_LINKEDIN,
    lazy: () => import("modules/onboarding/pages/OnboardingFreelancerLinkedin"),
  },
  {
    path: ONBOARDING_RESUME,
    lazy: () => import("modules/onboarding/pages/OnboardingFreelancerResume"),
  },
] as RouteObject[];
